var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGroupUsers = function SvgGroupUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2222 17.0003V15.2225C15.2222 14.2796 14.8476 13.3752 14.1808 12.7084C13.514 12.0416 12.6097 11.667 11.6667 11.667H4.55556C3.61256 11.667 2.70819 12.0416 2.0414 12.7084C1.3746 13.3752 1 14.2796 1 15.2225V17.0003",
    stroke: "#4B97E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11122 8.11111C10.0749 8.11111 11.6668 6.51923 11.6668 4.55556C11.6668 2.59188 10.0749 1 8.11122 1C6.14754 1 4.55566 2.59188 4.55566 4.55556C4.55566 6.51923 6.14754 8.11111 8.11122 8.11111Z",
    stroke: "#4B97E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5556 17V15.2222C20.555 14.4344 20.2928 13.6691 19.8101 13.0465C19.3275 12.4239 18.6517 11.9792 17.8889 11.7822",
    stroke: "#4B97E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7778 17V15.2222C26.7772 14.4344 26.515 13.6691 26.0323 13.0465C25.5496 12.4239 24.8739 11.9792 24.1111 11.7822",
    stroke: "#4B97E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 1.11523C15.0981 1.31106 15.776 1.75586 16.26 2.37951C16.7441 3.00316 17.0069 3.77019 17.0069 4.55968C17.0069 5.34916 16.7441 6.11619 16.26 6.73985C15.776 7.3635 15.0981 7.8083 14.3333 8.00412",
    stroke: "#4B97E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5557 1.11523C21.3205 1.31106 21.9984 1.75586 22.4825 2.37951C22.9665 3.00316 23.2293 3.77019 23.2293 4.55968C23.2293 5.34916 22.9665 6.11619 22.4825 6.73985C21.9984 7.3635 21.3205 7.8083 20.5557 8.00412",
    stroke: "#4B97E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroupUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/group_users.f0f2022c.svg";
export { ForwardRef as ReactComponent };